import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { PaxErrorPage } from "@ncino/pax-ui";
import { UserIcon } from "@phosphor-icons/react";

const RouteComponent = () => {
  const nav = useNavigate();
  return (
    <PaxErrorPage
      header={"Under Construction"}
      subtext={"This page is still under construction"}
      actionLabel={"Return to Home"}
      onAction={() => nav({ to: "/" })}
    />
  );
  /*<Outlet />*/
};

export const Route = createFileRoute("/institutions")({
  component: RouteComponent,
  staticData: {
    breadcrumb: { title: ({ t }) => t("breadcrumbs.institutions"), icon: UserIcon },
  },
});
